import * as ProjectListI from "./ProjectList";
import * as IssueListI from "./IssueList";

export const SequencePattern: Record<string, Record<string, Record<string, any>>> = {
  ProjectList: {
    default: {
      Action: ProjectListI.Action,
      START: ProjectListI.Start,
    },
  },
  IssueList: {
    default: {
      Action: IssueListI.Action,
      START: IssueListI.Start,
    },
  },
};

export default SequencePattern;